import React, {useEffect} from "react"
import {ButtonContact} from "~/common/components/atoms/button-contact/button-contact"
import {Spacing} from "~/common/components/templates/spacing"
import JumboPic from "./assets/jumbo.inline.svg"
import "./jumbotron.scss"

export function Jumbotron() {
  useEffect(() => {
    // internet explorer hack
    const bodyStyle = window.getComputedStyle(document.body)
    const supportsBackgroundBlendMode = bodyStyle["backgroundBlendMode"]
    if (!supportsBackgroundBlendMode) {
      document.querySelector(".jumbo__bgn")?.classList.add("jumbo__bgn_none")
    }
  }, [])

  return (
    // <CanvasBg>
    <div className="jumbo" id="top">
      {/* <div className="jumbo__top-line"></div> */}
      <div className="jumbo__bgn jumbo__bgn_dots">
        <div className="container">
          <div className="jumbo__cols">
            <div className="jumbo__col-1">
              <div className="jumbo__title title">
                <h1 className="title__heading">
                  Microsoft Office <br />
                  Custom Solutions Platform
                </h1>
                <div className="title__subheading">Cloud Templates &amp; Add-ins</div>
                <div className="jumbo__p">
                  We help companies to setup <em>optimised document processing flow</em> which significantly improve
                  productivity and promote best practices.
                </div>
                {/* <p className="jumbo__p">
                    We audit your company existing document processes and based on our expertise advise on best possible
                    tools and solutions.
                  </p> */}
                <Spacing value={20} />
                <div>
                  <div className="demo-button-wrapper">
                    <span style={{width: 170, display: "inline-block"}}>
                      <ButtonContact>Request a demo</ButtonContact>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="jumbo__col-2">
              {/* <div className="jumbo__pic"></div> */}
              <div className="jumbo__pic-2">
                <JumboPic />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    // </CanvasBg>
  )
}
